<div class="offering-support-channels">
  <h1 class="ui-heading-1-bold offering-support-channels-title">
    {{ section() }}
  </h1>

  @for (supportChannel of supportChannels(); track $index) {
    <rds-basic-card layout="horizontal">
      @if (supportChannel.channelType === SupportChannel.EMAIL) {
        <rds-icon color="primary" namespace="outlined" icon="email" />
      }

      @if (supportChannel.channelType === SupportChannel.PHONE) {
        <rds-icon color="primary" namespace="outlined" icon="call" />
      }

      @if (supportChannel.channelType === SupportChannel.CHAT) {
        <rds-icon color="primary" namespace="outlined" icon="chat" />
      }

      @if (supportChannel.channelType === SupportChannel.SERVICE_NOW) {
        <rds-icon color="primary" namespace="outlined" icon="circle_info" />
      }

      @if (supportChannel.channelType === SupportChannel.OTHER) {
        <rds-icon color="primary" namespace="outlined" icon="circle_help" />
      }
      <rds-card-header>
        <rds-card-title class="ui-label-m-bold">{{
          supportChannel.channelType
        }}</rds-card-title>
      </rds-card-header>
      <rds-card-content>
        <div class="offering-support-channels-content">
          <p class="article-body-m">
            {{ supportChannel.description }}
          </p>
          <a
            class="link"
            rds-link
            standalone
            [href]="getDestinationHref(supportChannel)"
            target="_blank"
          >
            {{
              supportChannel.destinationValue ?? supportChannel.serviceDeskName
            }}
            <rds-icon namespace="filled" icon="arrow_right" />
          </a>
        </div>
      </rds-card-content>
    </rds-basic-card>
  }
</div>
